import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';

import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';

import SaveCustomerOrderDevices from '../../../services/SaveCustomerOrderDevices';
import ReloadViewModule from '../../../services/ReloadViewModule';

import tmplRelocationFormView from './RelocationFormView.hbs';

const RelocationFormView = View.extend({
  template: tmplRelocationFormView,

  className: 'relocation-form-view',

  ui: {
    devicesAlert: '.no-devices-error',
    deviceMake: 'input[name="deviceMake"]',
    deviceModel: 'input[name="deviceModel"]',
    deviceSerialNumber: 'input[name="deviceSerialNumber"]',
  },

  onRender() {
    Syphon.deserialize(this, this.model.get('orderItems'));
  },

  async onSave() {
    this.ui.devicesAlert.hide();
    this.trigger('no:errors')
    const serialFormData = Syphon.serialize(this);
    const formData = {
      devicesFormData: serialFormData,
      orderId: this.model.get('orderDetails').orderId,
      orderTypeId: this.model.get('orderDetails').orderTypeId
    };

    try {
      await SaveCustomerOrderDevices(formData);
      await ReloadViewModule.reload();
      this.showSaveSuccess();
    } catch (err) {
      this.showSaveError();
      throw new Error(err);
    }
  },

  validate() {
    let isValid = true;
    if (!this.ui.deviceMake.val() ||!this.ui.deviceModel.val() || !this.ui.deviceSerialNumber.val() ) {
      isValid = false;
      this.ui.devicesAlert.show();
    }
    isValid ? this.trigger('no:errors') : this.trigger('has:errors');
    return isValid;
  },

  showSaveError() {
    showErrorMessage({
      errorCode: 'saveError',
      errorTitle: 'Save Error',
      errorMessage:
        'An error occurred while saving order form. Try again or contact an administrator if your issue persists.'
    });
  },

  showSaveSuccess() {
    showSuccessMessage({
      code: 'saveSuccess',
      title: 'Save Success',
      message: 'This order has been saved successfully.',
      hideAfter: 5
    });
  }
});

export default RelocationFormView;
